import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact Us" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[84px] flex items-center justify-between">
        <Link to="/" aria-label="RIDGELINE DIGI PARTNER home">
          <Logo />
        </Link>
        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-blue-400" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-consultation-btn"
            onClick={() => navigate("/contact")}
            className="hidden md:inline-flex items-center rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_0_24px_rgba(37,99,235,0.45)] transition-all duration-300 hover:bg-blue-500 hover:shadow-[0_0_36px_rgba(37,99,235,0.7)] hover:-translate-y-0.5"
          >
            Get a Free Consultation
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-slate-200 p-2"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <Menu className="hidden" /> : null}
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-slate-950/95 backdrop-blur-xl px-5 py-4" aria-label="Mobile">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-3 text-base font-medium border-b border-white/5 ${
                  isActive ? "text-blue-400" : "text-slate-200"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              navigate("/contact");
            }}
            className="mt-4 w-full rounded-full bg-blue-600 px-5 py-3 text-sm font-semibold text-white"
          >
            Get a Free Consultation
          </button>
        </nav>
      )}
    </header>
  );
}
